import { Dialog, DialogActions, DialogContent, styled } from '@mui/material';
/**
 * Styled Dialog component.
 */
export const HelixModal = styled(Dialog)(() => ({
    '& .MuiPaper-root': {
        borderRadius: '1.5rem',
        maxWidth: '40.5 rem',
        width: '40.5 rem',
    },
}));
export const HelixModalFooter = styled(DialogActions)(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0.5rem 1.5rem  1rem 1.5rem',
    gap: '1rem',
    '& button': {
        margin: 0,
    },
}));
export const HelixModalContent = styled(DialogContent)(() => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem 1.5rem',
    gap: '1rem',
}));
